/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/img-redundant-alt */
import React, { useMemo, useState } from "react";
import { Formik } from "formik";
import { merge } from "lodash";

import {
  useHtmlClassService,
  setLayoutConfig,
  getInitLayoutConfig,
} from "../../../../../_metronic/layout";

import { NoticeEvaluasi, YearSelect } from "../../../../../_metronic/_partials/controls";

import BentukKetercapaianMsStudi from "../content/BentukKetercapaianMsStudi";
import BentukKetercapaianIpkMhs from "../content/BentukKetercapaianIpkMhs";
import BentukKetercapaianDsn from "../content/BentukKetercapaianDsn";
import BentukEvaluasi from "../content/BentukEvaluasi";
import BentukEvaluasiLainnya from "../content/BentukEvaluasiLainnya";
import MasaStudi from "../../Penetapan/content/MasaStudi";

const localStorageActiveTabKey = "builderActiveTab";

export function TabsEvaluasi(params) {
  const getInitialTab = () => {
    const saved = localStorage.getItem(localStorageActiveTabKey);
    const parsed = Number(saved);

    if ([1, 2, 3].includes(parsed)) {
      return parsed;
    }

    return 1;
  };

  const [key, setKey] = useState(() => getInitialTab());

  const [, setIsLoading] = useState(false);

  const htmlClassService = useHtmlClassService();

  const initialValues = useMemo(
    () =>
      merge(
        getInitLayoutConfig(),
        htmlClassService.config
      ),
    [htmlClassService.config]
  );

  const saveCurrentTab = (tab) => {
    if ([1, 2, 3].includes(tab)) {
      localStorage.setItem(localStorageActiveTabKey, tab);
    }
  };

  const dataMasaStudi = params.ref_dosen_tetap;
  const dataIPK = params.ref_ipk;
  const data_dosen = params.ref_dosen_tetap;
  const Display = params.display;

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          setIsLoading(true);
          setLayoutConfig(values);
        }}
        onReset={() => {
          setIsLoading(true);
          setLayoutConfig(getInitLayoutConfig());
        }}
      >
        {() => (
          <>
            <NoticeEvaluasi
              svg="/media/svg/icons/Home/Building.svg"
              style={{ marginBottom: "20px", boxShadow: "none" }}
            >
              <div className="d-flex align-items-center justify-content-between w-100">
                <div>
                  <strong style={{ fontSize: "18px" }}>Evaluasi</strong>
                  <p className="mb-0">Bentuk Evaluasi Yang Dijalankan & Melalui Mekanisme</p>
                </div>
                <div>
                  <YearSelect />
                </div>
              </div>
            </NoticeEvaluasi>

            <div className="card card-custom">
              <div
                className="card-header card-header-tabs-line"
                style={{ minHeight: "50px" }}
              >
                <ul
                  className="nav nav-dark nav-bold nav-tabs nav-tabs-line"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 1 ? "active" : ""}`}
                      onClick={() => {
                        setKey(1);
                        saveCurrentTab(1);
                      }}
                    >
                      Evaluasi
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 2 ? "active" : ""}`}
                      onClick={() => {
                        setKey(2);
                        saveCurrentTab(2);
                      }}
                    >
                      Mahasiswa
                    </a>
                  </li>

                  <li className="nav-item">
                    <a
                      className={`nav-link py-5 ${key === 3 ? "active" : ""}`}
                      onClick={() => {
                        setKey(3);
                        saveCurrentTab(3);
                      }}
                    >
                      Dosen
                    </a>
                  </li>
                </ul>
              </div>

              <div className="form">
                <div className="card-body">
                  <div className="tab-content">
                    <div className={`tab-pane ${key === 2 ? "active" : ""}`}>
                      <div className="card card-custom" style={{ boxShadow: "none" }}>
                        <div className="text-center">
                          <strong style={{ fontSize: "20px" }}>MAHASISWA</strong>
                          <p>
                            Masa Studi Maksimal Dan IPK Minimal di Setiap Program Pendidikan
                            di Perguruan Tinggi Berdasarkan SNDIKTI
                          </p>
                        </div>

                        <BentukKetercapaianMsStudi
                          idSp={params.idSp}
                          masa_studi={dataMasaStudi}
                          display={Display}
                        />

                        <br />
                        <hr style={{ borderTop: "1px dashed" }} />

                        <BentukKetercapaianIpkMhs
                          idSp={params.idSp}
                          data_ipk={dataIPK}
                          display={Display}
                        />
                      </div>
                    </div>

                    <div className={`tab-pane ${key === 3 ? "active" : ""}`}>
                      <div className="text-center">
                        <strong style={{ fontSize: "20px" }}>DOSEN</strong>
                        <p>
                          Jumlah Dosen Tetap Berdasarkan di Setiap Program Pendidikan
                          di Perguruan Tinggi Berdasarkan SNDIKTI
                        </p>
                      </div>

                      <BentukKetercapaianDsn
                        idSp={params.idSp}
                        data_dosen={data_dosen}
                        display={Display}
                      />
                    </div>

                    <div className={`tab-pane ${key === 1 ? "active" : ""}`}>
                      <div className="text-center">
                        <strong style={{ fontSize: "20px" }}>EVALUASI</strong>
                        <p>
                          Laporan Pelaksanaan dan Hasil Evaluasi Yang Dilakukan
                        </p>
                      </div>

                      <BentukEvaluasiLainnya idSp={params.idSp} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </>
  );
}